import { render, staticRenderFns } from "./OAuthCallback.vue?vue&type=template&id=12e190ef&scoped=true&"
import script from "./OAuthCallback.vue?vue&type=script&lang=js&"
export * from "./OAuthCallback.vue?vue&type=script&lang=js&"
import style0 from "./OAuthCallback.vue?vue&type=style&index=0&id=12e190ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e190ef",
  null
  
)

export default component.exports